import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { SentryErrorHandler } from './sentry-error-handler.service';
import { ReloadOnChunksFailHandler } from './reload-on-chunks-fail.service';
import { environment } from '~env/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MainErrorHandler implements ErrorHandler {
  constructor(
    private readonly sentryErrorHandler: SentryErrorHandler,
    private readonly reloadOnChunksErrorHandler: ReloadOnChunksFailHandler,
    @Inject(PLATFORM_ID) private platform: Object
  ) {}

  public handleError(error: Error): void {
    if (!environment.production) {
      console.error(error);
    }

    this.sentryErrorHandler.handleError(error);
    this.reloadOnChunksErrorHandler.handleError(error);
  }
}
